import { JobType } from './types'

export const EXPORTABLE_JOB_TYPES = [JobType.DatasetExport, JobType.WorkflowDataExport]
